export default class {
    constructor(
    ) {
        this.status = arguments[0];
        this.status_text = arguments[1];
        this.message = arguments[2];
    };
};